var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-slide-group',{staticClass:"mt-2",attrs:{"show-arrows":_vm.show_arrow}},_vm._l((_vm.bizs),function(biz){return _c('v-slide-item',{key:biz._id},[_c('Cell',{attrs:{"biz":biz}})],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }